/* =============================================================================
   Legere Parts — favoritos e vistos recentemente

   Tudo vive no localStorage do navegador do cliente. Não sincroniza com a conta
   nem entre dispositivos — isso exigiria um app. As páginas hidratam os produtos
   por /products/{handle}.js, então preço e disponibilidade vêm sempre da Shopify.
   ========================================================================== */
(function () {
  'use strict';

  const T = window.LegereTheme;
  const { toast, formatMoney } = T.utils;

  const KEYS = {
    wishlist: 'legere:wishlist',
    recent: 'legere:recent',
  };
  const RECENT_LIMIT = 8;

  /* --- Armazenamento ------------------------------------------------------- */

  function read(key) {
    try {
      const raw = localStorage.getItem(key);
      const value = raw ? JSON.parse(raw) : [];
      return Array.isArray(value) ? value : [];
    } catch (_) {
      // Navegação privada ou storage bloqueado: a lista some, o site continua.
      return [];
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_) {
      /* sem espaço ou sem permissão — nada a fazer */
    }
  }

  /* --- Contadores e estado dos botões -------------------------------------- */

  function syncBadges() {
    const wishlist = read(KEYS.wishlist);

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = wishlist.length;
      el.hidden = wishlist.length === 0;
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const active = wishlist.includes(btn.dataset.wishlistToggle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  function toggle(key, handle, limit) {
    const list = read(key);
    const index = list.indexOf(handle);

    if (index >= 0) {
      list.splice(index, 1);
      write(key, list);
      syncBadges();
      return 'removed';
    }
    if (limit && list.length >= limit) return 'full';

    list.push(handle);
    write(key, list);
    syncBadges();
    return 'added';
  }

  /* --- Eventos ------------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    const wishBtn = event.target.closest('[data-wishlist-toggle]');
    if (!wishBtn) return;
    event.preventDefault();
    const result = toggle(KEYS.wishlist, wishBtn.dataset.wishlistToggle);
    toast(result === 'added' ? T.strings.wishlistAdded : T.strings.wishlistRemoved);
    if (document.querySelector('[data-wishlist-grid]')) renderWishlist();
  });

  /* --- Hidratação de produtos ---------------------------------------------- */

  const cache = new Map();

  async function fetchProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    try {
      const res = await fetch(`${T.routes.root}products/${handle}.js`);
      if (!res.ok) return null;
      const product = await res.json();
      cache.set(handle, product);
      return product;
    } catch (_) {
      return null;
    }
  }

  async function fetchAll(handles) {
    const products = await Promise.all(handles.map(fetchProduct));
    // Produtos removidos ou despublicados somem da lista em vez de virar erro.
    const alive = products.filter(Boolean);
    return alive;
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function cardHtml(product, options) {
    const removable = !options || options.removable !== false;
    const image = product.featured_image
      ? `<img src="${product.featured_image}" alt="${escapeHtml(product.title)}" loading="lazy">`
      : '';
    return `
      <article class="list-card">
        <a class="list-card__media" href="${product.url}">${image}</a>
        <div class="list-card__body">
          <p class="list-card__vendor">${escapeHtml(product.vendor || '')}</p>
          <h3 class="list-card__title"><a href="${product.url}">${escapeHtml(product.title)}</a></h3>
          <p class="price"><span class="price__current">${formatMoney(product.price)}</span></p>
        </div>
        <div class="list-card__actions">
          <form action="${T.routes.cartAdd}" method="post" data-add-to-cart>
            <input type="hidden" name="id" value="${product.variants[0].id}">
            <button class="btn btn--primary btn--sm btn--full" type="submit" ${
              product.available ? '' : 'disabled'
            }>${product.available ? T.strings.addToCart : T.strings.soldOut}</button>
          </form>
          ${
            removable
              ? `<button class="btn btn--ghost btn--sm btn--full" data-wishlist-toggle="${product.handle}" type="button">
            ${T.strings.remove}
          </button>`
              : ''
          }
        </div>
      </article>`;
  }

  /* --- Página de favoritos -------------------------------------------------- */

  async function renderWishlist() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    const handles = read(KEYS.wishlist);
    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    const products = await fetchAll(handles);
    grid.innerHTML = products.map(cardHtml).join('');
    syncBadges();
  }

  /* --- Vistos recentemente -------------------------------------------------- */

  function trackRecent() {
    const meta = document.querySelector('[data-recent-track]');
    if (!meta || !T.features.recentlyViewed) return;
    const handle = meta.dataset.recentTrack;
    const list = read(KEYS.recent).filter((h) => h !== handle);
    list.unshift(handle);
    write(KEYS.recent, list.slice(0, RECENT_LIMIT));
  }

  async function renderRecent() {
    const grid = document.querySelector('[data-recent-grid]');
    if (!grid) return;
    const current = grid.dataset.exclude;
    const handles = read(KEYS.recent).filter((h) => h !== current);
    if (!handles.length) {
      const section = grid.closest('[data-recent-section]');
      if (section) section.hidden = true;
      return;
    }
    const products = await fetchAll(handles);
    if (!products.length) return;
    grid.innerHTML = products
      .map((product) => `<li>${cardHtml(product, { removable: false })}</li>`)
      .join('');

    // O carrossel foi inicializado com a trilha ainda vazia (o conteúdo só
    // chega depois, aqui em cima) — os botões de seta ficaram desabilitados
    // achando que não havia nada pra rolar. Um "resize" sintético força o
    // recálculo (initCarousel escuta esse evento pra reavaliar os limites).
    window.dispatchEvent(new Event('resize'));
  }

  /* --- Inicialização -------------------------------------------------------- */

  document.addEventListener('DOMContentLoaded', () => {
    syncBadges();
    trackRecent();
    renderWishlist();
    renderRecent();
  });

  document.addEventListener('shopify:section:load', syncBadges);

  T.lists = { read, write, syncBadges, KEYS };
})();
